import {DDR} from '../micronutrient-ddr-strategy/ddr.class';
import {DDRTypeEnum} from './ddr-type.enum';
import {
  DDRLactatingMother18Strategy,
  DDRLactatingMother1930Strategy,
  DDRLactatingMother3150Strategy,
  DDRMen1418Strategy,
  DDRMen1930Strategy,
  DDRMen3150Strategy,
  DDRMen5170Strategy,
  DDRMen70Strategy,
  DDRMen913Strategy,
  DDRPregnant18Strategy,
  DDRPregnant1930Strategy,
  DDRPregnant3150Strategy,
  DDRWoman1418Strategy,
  DDRWoman1930Strategy,
  DDRWoman3150Strategy,
  DDRWoman5170Strategy,
  DDRWoman70Strategy,
  DDRWoman913Strategy
} from '../micronutrient-ddr-strategy';

export class DDRFactory {
  public static createDDRStandar(type: DDRTypeEnum): DDR {
    switch (type) {
      case DDRTypeEnum.LACTATINGMOTHER18:
        return new DDRLactatingMother18Strategy();
      case DDRTypeEnum.LACTATINGMOTHER1930:
        return new DDRLactatingMother1930Strategy();
      case DDRTypeEnum.LACTATINGMOTHER3150:
        return new DDRLactatingMother3150Strategy();
      case DDRTypeEnum.PREGNANT18:
        return new DDRPregnant18Strategy();
      case DDRTypeEnum.PREGNANT1930:
        return new DDRPregnant1930Strategy();
      case DDRTypeEnum.PREGNANT3150:
        return new DDRPregnant3150Strategy();
      case DDRTypeEnum.MEN913:
        return new DDRMen913Strategy();
      case DDRTypeEnum.MEN1418:
        return new DDRMen1418Strategy();
      case DDRTypeEnum.MEN1930:
        return new DDRMen1930Strategy();
      case DDRTypeEnum.MEN3150:
        return new DDRMen3150Strategy();
      case DDRTypeEnum.MEN5170:
        return new DDRMen5170Strategy();
      case DDRTypeEnum.MEN70:
        return new DDRMen70Strategy();
      case DDRTypeEnum.WOMAN913:
        return new DDRWoman913Strategy();
      case DDRTypeEnum.WOMAN1418:
        return new DDRWoman1418Strategy();
      case DDRTypeEnum.WOMAN1930:
        return new DDRWoman1930Strategy();
      case DDRTypeEnum.WOMAN3150:
        return new DDRWoman3150Strategy();
      case DDRTypeEnum.WOMAN5170:
        return new DDRWoman5170Strategy();
      case DDRTypeEnum.WOMAN70:
        return new DDRWoman70Strategy();
      default:
        return new DDRMen1930Strategy();
    }
  }
}
